module.exports = __webpack_public_path__ + "static/media/360-dialog.5514fa6a.svg";